import styled from 'styled-components';

const StyleWrapper = styled.div`
  display: flex;
  .side {
    width: 50vw;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    &.banner-side {
      background: ${({ theme }) => theme.colors.primary};
      position: relative;
      overflow: hidden;
      .element-tl {
        position: absolute;
        width: 456px;
        height: 458px;
        left: -316px;
        top: -213px;

        background: rgba(227, 176, 113, 0.61);
        filter: blur(200px);
      }
      .element-tr {
        position: absolute;
        width: 353px;
        height: 456px;
        right: 0;
        top: -108px;

        background: rgba(255, 255, 255, 0.36);
        filter: blur(234px);
      }
      .element-bl-rotated {
        position: absolute;
        width: 500px;
        height: 496px;
        left: 20%;
        bottom: -310.2px;

        background: rgba(255, 255, 255, 0.71);
        opacity: 0.5;
        filter: blur(154px);
        transform: rotate(106.42deg);

      }
    }
    .main-content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      .chat-img {
        filter: drop-shadow(0px 24px 94px rgba(255, 255, 255, 0.25));
      }
      .stat-img {
        max-width: 500px;
      }
      p {
        max-width: 400px;
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 25px;
        text-align: center;
        color: #FFFFFF;;
      }
    }
  }
  
  .form-wrapper {
    position: relative;
    padding: 0 16px;
    width: 348px;
    .form-header {
      padding-top: 74px;
      padding-bottom: 25px;
      .title {
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 29px;
      }
      a {
        color: ${({ theme }) => theme.colors.primary};
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        text-align: right;
        text-decoration-line: underline;
        &:hover {
          text-decoration: none;
        }
      }
    }
    .form-group {
      margin-bottom: 16px;
      position: relative;
      .form-control {
        &.is-invalid {
          border-color: ${({ theme }) => theme.colors.warning};
        }
      } 
      label {
        padding-left: 1px;
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        padding-bottom: 4px;
        color: ${({ theme }) => theme.colors.primaryGray};
        .asterisk {
          color: ${({ theme }) => theme.colors.warning};
        }
      }
      .invalid-feedback {
        position: absolute;
        top: calc(100% + 4px);
        padding-left: 1px;
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 14px;
        color: ${({ theme }) => theme.colors.warning};
      }
    }
    .form-warning {
      position: absolute;
      left: 17px;
      top: 100%;
      padding-top: 4px;
      font-family: 'Manrope', sans-serif;
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.warning};
    }
  }

  button {
    height: 50px;
    width: 100%;
    background: ${({ theme }) => theme.colors.primary};
    border-radius: 8px;
    font-family: 'Manrope', sans-serif;
    font-style: normal;
    font-weight: 800;
    font-size: 15px;
    line-height: 20px;
    color: #FFFFFF;
    span {
      position: relative;
      .loading {
        position: absolute;
        top: 50%;
        margin-top: -10px;
        right: calc(100% + 5px);
        
      }
    }
  }

  .logo-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 35px;
    .sub-logo {
      font-family: 'Manrope', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 17px;
      line-height: 23px;
      text-align: center;
      margin-top: 25px;
      margin-bottom: 25px;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
  
  .controls-group {
    padding: 25px 0;
    a {
      color: ${({ theme }) => theme.colors.primary};
      font-family: 'Manrope', sans-serif;
      font-style: normal;
      font-weight: 800;
      font-size: 15px;
      line-height: 20px;
    }
    
    &.controls {
      background: ${({ theme }) => theme.colors.infoArea};
      border-radius: 10px;
      padding: 25px 15px;
    }
    &:last-child {
      border-bottom: 0;
    }
    .label {
      font-family: 'Manrope', sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: 14px;
      line-height: 19px;
      margin-bottom: 4px;

      color: #888888;
      &.xs {
        font-size: 12px;
        line-height: 16px;
        text-align: center;
      }
    }
    label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
      p {
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 700;
        font-size: 14px;
        line-height: 19px;
        color: ${({ theme }) => theme.colors.secondary};
        span {
          color: ${({ theme }) => theme.colors.primary};
        }
      } 
    }
    .field {
      position: relative;
      .error {
        position: absolute;
        left: 0;
        top: calc(100% + 5px);
        font-family: 'Manrope', sans-serif;
        font-style: normal;
        font-weight: 800;
        font-size: 12px;
        line-height: 14px;
        color: red;
      }
    }
  }

  input {
    width: 100%;
    border: 1.5px solid ${({ theme }) => theme.colors.primary};
    background: ${({ theme }) => theme.colors.inputBg};
    color: ${({ theme }) => theme.colors.secondary};
    box-sizing: border-box;
    border-radius: 10px;
    outline: 0;
    height: 44px;
    padding: 5px 17px;
    font-style: normal;
    font-weight: 500;
    font-size: 16.675px;
    line-height: 23px;
    letter-spacing: 0.02em;
  }

  .checkbox-wrapper {
    width: 22px;
    display: block;
    position: relative;
    cursor: pointer;
    height: 22px;
    font-size: 22px;
    user-select: none;
    input {
      display: none;
    }
    .checkmark {
      position: absolute;
      top: 0;
      left: 0;
      height: 22px;
      width: 22px;
      border-radius: 4px;
      border: 1.5px solid ${({ theme }) => theme.colors.primary};
      background: ${({ theme }) => theme.colors.inputBg};
      &:after {
        content: "";
        position: absolute;
        display: none;
        left: 7px;
        top: 2px;
        width: 6px;
        height: 12px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }
    
    input:checked ~ .checkmark {
      background-color: ${({ theme }) => theme.colors.primary};
    }
    
    input:checked ~ .checkmark:after {
      display: block;
    }
  }
  
`;

export default StyleWrapper;